import createIcon from '../../createIcon';

/**
 * @component @name TwokPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk05LjUgMTEuNUM5LjUgMTIuMDUgOS4wNSAxMi41IDguNSAxMi41SDYuNVYxMy41SDkuNVYxNUg1VjEyLjVDNSAxMS45NSA1LjQ1IDExLjUgNiAxMS41SDhWMTAuNUg1VjlIOC41QzkuMDUgOSA5LjUgOS40NSA5LjUgMTBWMTEuNVpNMTQuMjUgMTVMMTIuNSAxMi43NVYxNUgxMVY5SDEyLjVWMTEuMjVMMTQuMjUgOUgxNkwxMy43NSAxMkwxNiAxNUgxNC4yNVpNMjAgMTIuNUgxOC41VjE0SDE3LjVWMTIuNUgxNlYxMS41SDE3LjVWMTBIMTguNVYxMS41SDIwVjEyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TwokPlus = createIcon('TwokPlus', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9.5 11.5C9.5 12.05 9.05 12.5 8.5 12.5H6.5V13.5H9.5V15H5V12.5C5 11.95 5.45 11.5 6 11.5H8V10.5H5V9H8.5C9.05 9 9.5 9.45 9.5 10V11.5ZM14.25 15L12.5 12.75V15H11V9H12.5V11.25L14.25 9H16L13.75 12L16 15H14.25ZM20 12.5H18.5V14H17.5V12.5H16V11.5H17.5V10H18.5V11.5H20V12.5Z',
      key: 'ivfeda',
    },
  ],
]);

export default TwokPlus;
